import React from "react";
import { Sidebar } from "./Sidebar";

export const AboutProject = () => {
  return (
    <div>
      <Sidebar />
      <div id="content">
        <h1>About Project</h1>
      </div>
    </div>
  );
};
